export default "/images/reset-password.svg?874b176ac4887347712b48f62903f997";